import { createFileRoute } from "@tanstack/react-router";
import { BrokerageAccountsAlpaca } from "@/components/BrokerageAccountsAlpaca";

function RouteComponent() {
  return <BrokerageAccountsAlpaca />;
}

export const Route = createFileRoute("/_authenticated/brokerage-accounts-alpaca/")({
  component: RouteComponent,
  staticData: { page: "banking" },
});
